import { useQuery } from '@apollo/react-hooks';
import {gql} from 'apollo-boost';

const GET_POPULAR_BRANDS = gql`
  {
    getPopularKeywordsByFilterCached {
      popularBrands {
        id
        name_kr
        name
        resizedSmallLogo
      }
    }
  }
`;

export const usePopularBrands = () => {
  const {
    loading,
    error,
    data
  } = useQuery(GET_POPULAR_BRANDS);

  return { loading, error, data };
};
